import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationService, Notification } from '../../../core/services/notification';

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './notification.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationComponent {
  constructor(private notificationService: NotificationService) {}

  get notifications() {
    return this.notificationService.notifications;
  }

  getClass(type: Notification['type']): string {
    switch (type) {
      case 'success':
        return 'bg-green-100 text-green-700 border-green-400';
      case 'danger':
        return 'bg-red-100 text-red-700 border-red-400';
      case 'warning':
        return 'bg-yellow-100 text-yellow-700 border-yellow-400';
      case 'info':
        return 'bg-blue-100 text-blue-700 border-blue-400';
      default:
        return 'bg-blue-100 text-blue-700 border-blue-400';
    }
  }

  close(id: number) {
    this.notificationService.close(id);
  }
}
